import { ExcelManagementEffects } from './excel-management/excel-management.effects';
import { MachineListEffects } from './machine-list/machine-list.effects';
import { LocationListEffects } from './location-management/location-management.effects';
import { EmployeeListEffects } from './employee-management/employee-management.effects';
import { BreakdownReasonsEffects } from './breakdown-reasons/breakdown-reasons.effects';
import { LineSetupEffects } from './line-setup/line-setup.effects';
import { TicketManagementEffects } from './ticket-management/ticket-management.effects';
import { MachineServiceListEffects } from './machine-service/machine-service.effects';
import { SparePartListEffects } from './sparepart-list/sparepart-list.effects';
import { NeedleManagementEffects } from './needle-management/needle-management.effects';
import { MechanicDashboardEffects } from './mechanic-dashboard/mechanic-dashboard.effects';
import { ConfigSetupEffects } from './config-setup/config-setup.effects';
import { NptEffects } from './npt/npt.effects';
import { AttachmentEffects } from './attachment/attachment.effects';
import { ChatbotEffects } from './chatbot/chatbot.effects';
import { QcoEffects } from './qco/qco.effects';
import { ShiftManagementEffects } from './shift-management/shift-management.effects';

export const machineMaintenanceEffects = [
  ExcelManagementEffects,
  MachineListEffects,
  SparePartListEffects,
  NeedleManagementEffects,
  LocationListEffects,
  EmployeeListEffects,
  MechanicDashboardEffects,
  BreakdownReasonsEffects,
  MachineServiceListEffects,
  LineSetupEffects,
  TicketManagementEffects,
  ConfigSetupEffects,
  NptEffects,
  AttachmentEffects,
  ChatbotEffects,
  QcoEffects,
  ShiftManagementEffects,
];
